export const LOGO_WIDTH = 116;
export const LOGO_HEIGHT = 32;
export const IMAGE_WIDTH = 295;
export const IMAGE_HEIGHT = 221;
export const IMAGE_MARGIN = 32;
export const ICON_DIMENSION = 34;
